export default "__VITE_ASSET__CXLCgPZ4__"